import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function EvolutionBarr(props) {
  const [evolutionBar, setEvolutionBar] = useState();
  const [secondEvolutionBar, setSecondEvolutionBar] = useState();
  const [surNext, setSurNext] = useState();

  //------
  const sendRequest = (endRequest, fonction) => {
    if (!endRequest) return;
    const requestURL = "https://pokebuildapi.fr/api/v1/pokemon/" + endRequest;

    fetch(requestURL)
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        return null;
      })
      .then((value) => {
        if (!value) return;
        fonction(value);
        if (value.apiEvolutions && value.apiEvolutions.length > 0) {
          setSurNext(value.apiEvolutions[0].pokedexId);
        } else {
          setSurNext(null);
        }
      })
      .catch(function (err) {
        // gérer l'erreur si nécessaire
      });
  };

  useEffect(() => {
    sendRequest(props.next.pokedexId, setEvolutionBar);
  }, [props.next.pokedexId]);

  useEffect(() => {
    if (!surNext) return;
    sendRequest(surNext, setSecondEvolutionBar);
  }, [surNext]);

  if (evolutionBar) {
    if (evolutionBar.apiEvolutions.length !== 0) {
      props.setSecondEvolutionExist(true);
    }
  }

  //------
  return (
    <div className="sm:flex sm:justify-center">
      {evolutionBar && (
        <Link to={`/pokemon/${evolutionBar.id}`}>
          <img
            src={evolutionBar.image}
            alt="pokemon"
            className="displayInitial max-h-32 mb-2"
          />
          <h1 className={`text-xl ${props.colorTitle} sm:text-base`}>
            {evolutionBar.name} # {evolutionBar.pokedexId}
          </h1>
        </Link>
      )}
      {secondEvolutionBar ? (
        evolutionBar.apiEvolutions.length !== 0 ? (
          <Link to={`/pokemon/${secondEvolutionBar.id}`}>
            <img
              src={secondEvolutionBar.image}
              alt="pokemon"
              className="displayInitial max-h-32 mb-2"
            />
            <h1 className={`text-xl ${props.colorTitle} sm:text-base`}>
              {secondEvolutionBar.name} # {secondEvolutionBar.pokedexId}
            </h1>
          </Link>
        ) : null
      ) : null}
    </div>
  );
}

export default EvolutionBarr;
